// src/pages/admin/assets/AssetsTablex

import React from 'react';
import DataTable from '../../components/common/DataTable';
import { Link } from 'react-router-dom';
import AssetBadge from '../../../shared/components/AssetBadge';
import { getAddressParts } from '../../../shared/utils/formatAddress';

export default function AssetsTable({ items, filterExtras = null }) {
  const columns = [
    {
      key: "asset_name",
      label: "Asset Name",
      sortable: true,

      render: row => (
        <>
          <i className="bi bi-boombox text-primary me-2" />
          <span className="fw-semibold">
            <Link to={`/admin/assets/${row.id}`} className="text-decoration-none">
              {row.asset_name}
            </Link>
          </span>
        </>
      ),
    },
    {
      key: "asset_make",
      label: "Make",
      sortable: true,
      render: row => row.asset_make,
    },
    {
      key: "asset_model",
      label: "Model",
      sortable: true,
      render: row => row.asset_model,
    },
    {
      key: 'asset_address',
      label: 'Address',
      sortable: true,
      render: row => {
        const parts = getAddressParts(row);
        if (parts.length === 0) return <span className="text-muted">—</span>;
        return (
          <div>
            <div>{parts[0]}</div>
            {parts[1] && <div className="text-muted small">{parts[1]}</div>}
          </div>
        );
      },
      filterValue: row => getAddressParts(row).join(' ')
    },
    {
      key: "asset_type",
      label: "Type",
      sortable: true,
      render: row => <AssetBadge asset={row} />,
    },
  ];

  return (
    <DataTable
      items={items}
      columns={columns}
      filterExtras={filterExtras}
      filterPlaceholder="Search assets…"
      emptyMessage="No assets match your filters."
    />
  );
}
